<template>
  <div>
    <transition-group v-if="edit" tag="div" name="scale" appear mode="out-in" class="tw-grid tw-gap-12 md:tw-gap-24 md:tw-grid-cols-3">
      <EditEvent v-for="event in events" :key="event.id" :event="event" @deleted="deleteEvent"/>
    </transition-group>
    <transition-group v-else tag="div" name="scale" appear mode="out-in" class="tw-py-28 tw-grid tw-gap-12 md:tw-gap-24 md:tw-grid-cols-3">
      <Event v-for="(event , index) in events" :key="event.id+index" :event="event"/>
    </transition-group>
  </div>
</template>

<script>
import EditEvent from "./EditEvent";
import Event from "./Event";
export default {
  name: "EventsListing",
  components: {Event, EditEvent},
  props: ['edit' , 'events'],
  methods : {
    deleteEvent(id) {
      this.$emit('deleted' , id);
    }
  }
}
</script>

<style lang="scss">
.scale-enter-active,
.scale-leave-active {
  transition: transform 0.5s ease;
}

.scale-enter-from,
.scale-leave-to {
  transform: scale(0);
}
</style>